module.exports = __webpack_public_path__ + "fe8370646e7aa3e3d0cc76deb7d0f0bb.pdf";